import * as React from 'react';
import { Col, Row } from 'reactstrap';
import FormInput from 'components/uielements/FormInput';
import RequestFormWrapper from './RequestForm.style';
import { formStructure } from '../RequestModal/FormStructure';
import type { RequestFormProps, InputsProps } from './RequestForm.types';

const Inputs = ({ form, onInputChange }: InputsProps): React.ReactElement<any> => {
  const lastIndex = formStructure.length - 1;
  const renderInputs: React.ReactElement<any>[] = formStructure.map((field, i) => {
    const { id, displayName } = field;
    const {
      errors: { [id]: errors },
      [id]: value,
    } = form;
    const colWidth = i === lastIndex && lastIndex % 2 === 0 ? 12 : 6;
    return (
      <Col key={id} xs={colWidth}>
        <FormInput
          {...field}
          className='request-form__input-field'
          errors={errors}
          label={displayName}
          name={id}
          onChange={onInputChange}
          value={value}
        />
      </Col>
    );
  });
  return <Row>{renderInputs}</Row>;
};

const RequestForm = ({ form, onInputChange }: RequestFormProps) => (
  <RequestFormWrapper>
    <Inputs form={form} onInputChange={onInputChange} />
  </RequestFormWrapper>
);

export default RequestForm;
